// #region Imports

/* Vue */
import Vue from 'vue'
import VueRouter from 'vue-router'

/* Telestream */
import GridFrame from '../GridFrame';
import GridView from '../views/GridView';
import Layout from '../views/Layout';
import ListFrame from '../ListFrame';
import NotAuthorized from '../views/NotAuthorized';
import Settings from '../views/Settings';
import System from '../views/System';
import Sessions from '../views/Sessions';
import { ConnectionService } from '@/services/connection.service';

// #endregion Imports

Vue.use(VueRouter);

const routes = [

  {
    path:      '/',
    component: GridFrame,
    children:  [
      {
        path:      '/',
        name:      'GridView',
        component: GridView
      },
      {
        path:      '/not-authorized',
        name:      'NotAuthorized',
        component: NotAuthorized
      },
      {
        path:      '/layout',
        name:      'Layout',
        component: Layout
      }
    ]
  },

  {
    path:      '/',
    component: ListFrame,
    children:  [
      {
        path:      '/settings',
        name:      'Settings',
        component: Settings
      },
      {
        path:      '/system',
        name:      'System',
        component: System
      },
      {
        path:      '/sessions',
        name:      'Sessions',
        component: Sessions
      }
    ]
  }

];

const router = new VueRouter({
  routes
});

// #region Route Protection

const PROTECTED_ROUTES    = ['Settings', 'System', 'Sessions'];
const LOCAL_DOMAINS       = ['localhost', '127.0.0.1'];
const ADMIN_VIEWS         = 'Admin';

router.beforeEach(async (to, from, next) => {
  // If route is not protected, allow:
  if (!PROTECTED_ROUTES.includes(to.name)) {
    next();
    return;
  }

  const connectionIsLocalhost = isConnectionLocalHost();
  const userIsAdmin = await isUserAdmin();

  // Is user is admin or connection is from localhost, allow:
  if (connectionIsLocalhost || userIsAdmin) {
    next();
    return;
  }

  // Send away otherwise:
  next('/not-authorized');
});

function isConnectionLocalHost() {
  return LOCAL_DOMAINS.includes(window.location.hostname);
}

async function isUserAdmin() {
  const connection = ConnectionService.getConnection('/ui-access');
  await connection.start();

  const allowedViews = new Set(await connection.invoke('GetAllowedViews'));

  connection.stop();
  
  return allowedViews.has(ADMIN_VIEWS);
}

// #endregion Route Protection

export default router;
